import { useContext } from 'react';
import { UserContext } from '../../contexts';
import { PrimaryButton } from '../atoms';

const ViewAsEPButton = ({ merchantId }: { merchantId: string }) => {
  const { user, onUserChange } = useContext(UserContext);
  const setMerchantIdInContext = (merchantId: string) => {
    onUserChange({
      merchantId: merchantId,
      userType: 'tenantAdmin',
      sub: user.sub,
      email: user.email
    });
  };

  return (
    <PrimaryButton
      type="button"
      disabled={user.merchantId === merchantId}
      onClick={(e: any) => {
        e.stopPropagation();
        setMerchantIdInContext(merchantId);
      }}
    >
      View as EP: {merchantId}
    </PrimaryButton>
  );
};

export { ViewAsEPButton };
